import BetsSlip from "components/betsSlip"
import BetsSlipForFancy from "components/betsSlipForFancy"

const Fancy = ({
    eventData,
    fancy,
    event_id,
    marketId,
    selection_id,
    setSelection_id,
    setHtmlId,
    type,
    handlePriceValue,
    BetPlaceData,
    placeStakeValue,
    StakeValue,
    setShowBetsSlip,
    showBetsSlip,
    handleOpenBetSlip,
    setSize,
    betPlace,
    is_fancy,
    checkHighestMarketPrice,
    loading,
    fancyExposure,
    checkFancyExposureExists,
    findFancyExposure,
    getFancyPosition,
    chips
}) => {
    return (
        <>
            <tr id="fancyBetMarket_332715" className="fancy-bet">
                <input type="hidden" id="fancy_id_preserve" value={fancy.market_id} />
                <td className="text-[#000] font-bold px-[.25rem] w-[60%] py-[2px] !pb-0 border-t-[1px] border-[#dee2e6]">
                    <div className="w-full in-play-title flex items-center ">
                        <div className="flex flex-col  w-[80%]">
                            <div className="flex items-center">
                                <a className="add-pin-d cursor-pointer bg-[url(https://images.staticcontent.io/rde/uimg/a-pin-mobile.svg)] !bg-contain h-[20px] mb-px w-[20px] border-[1px] border-[solid] border-[#7e97a7] rounded-[3px] mt-px p-0 inline-block float-left text-[14px] !leading-[13px] !mr-[.25rem]" title="Add to Multi Markets" ></a>
                                <span id="marketName" className="marketnamemobile inline-block !w-[88%]" title="170 Over KER">{fancy?.runner_name}</span>
                                <a className="p-0 w-[20px] rounded-[4px] cursor-pointer inline-block text-[14px] !leading-[13px] !float-right"></a>
                            </div>
                            <div>
                                <span id="before"
                                    onClick={() => getFancyPosition(fancy.selection_id)}
                                    className={`win fancywin win_${fancy.match_id}_${fancy.selection_id.replace('.', '___')} text-[0.688rem]  !font-bold cursor-pointer`}
                                    data-value={
                                        findFancyExposure(fancy.selection_id)
                                    }
                                >
                                    {
                                        checkFancyExposureExists(fancy.selection_id)
                                            ? <>{Math.abs(findFancyExposure(fancy.selection_id))}</> : null
                                    }
                                </span>
                            </div>
                        </div>
                        <div className="w-[20%]">
                            <a className="lg:hidden p-0 w-[20px] rounded-[4px] cursor-pointer text-[14px] !leading-[13px] !float-right">
                                <i className="fa fa-info-circle  text-[#53bbcd] text-[16px] -ml-px" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                </td>
                <td className="text-[#000] font-bold px-px py-[2px] relative text-center w-[40%] lg:w-[15.7%] border-t-[1px] border-[#dee2e6]">
                    {/* <div className="suspended-fancy ballrunning-fancy "> */}
                    <div className=" ">
                        <div id="lay_1">
                            <button type="button" id="btnLay" className="lay-1 btn-lay text-[#000]  min-h-[36px] rounded-[4px] cursor-pointer inline-block float-left text-[14px] !leading-[13px] px-[0] py-[5px] w-[49%] border-b-[1px] border-[#f1f1f1] mr-[1%]" side="Lay"
                                onClick={(e) =>
                                    fancy.game_status == '' &&
                                    handleOpenBetSlip(
                                        fancy.match_id,
                                        "",
                                        false,
                                        `fancy_lay_size_${fancy.selection_id}`,
                                        true,
                                        fancy.selection_id,
                                        fancy.runner_name,
                                        `fancy_lay_price_${fancy.selection_id}`,
                                        false,
                                        ''
                                    )
                                }
                            >
                                <div id={`fancy_lay_price_${fancy.selection_id}`} className="min-h-[12px] widthhundredfancy">{fancy?.lay_price1}</div>
                                <span id={`fancy_lay_size_${fancy.selection_id}`} className="text-[10px] widthhundredfancy">{fancy?.lay_size1}</span>
                            </button>
                        </div>
                        <div id="back_1">
                            {fancy.game_status != '' && (
                                <div className='p-[10px] w-[100%] right-[0] top-[0] bg-[url(https://images.staticcontent.io/rde/uimg/bg-disabled.png)] bg-[rgba(0,_0,_0,_.5)] absolute pointer-events-none h-full text-[#ffffff] flex justify-center items-center text-center font-bold text-[.75rem]'>
                                    <span className='block font-semibold text-[0.688rem] opacity-[.8] text-[red] [text-shadow:0_1px_4px_rgba(0,_0,_0,_.5)] text-center normal-case min-w-[50px] flex-[auto]'> {fancy.game_status} </span>
                                </div>
                            )}
                            <button type="button" id="btnBack" className="back-1 btn-back text-[#000]  min-h-[36px] rounded-[4px] cursor-pointer inline-block float-left text-[14px] !leading-[13px] px-[0] py-[5px] w-[49%] border-b-[1px] border-[#f1f1f1] mr-[1%]" side="Back" onClick={(e) =>
                                fancy.game_status == '' &&
                                handleOpenBetSlip(
                                    fancy.match_id,
                                    "",
                                    true,
                                    `fancy_back_size_${fancy.selection_id}`,
                                    true,
                                    fancy.selection_id,
                                    fancy.runner_name,
                                    `fancy_back_price_${fancy.selection_id}`,
                                    false,
                                    ''
                                )
                            }>
                                <div className="widthhundredfancy min-h-[12px]" id={`fancy_back_price_${fancy.selection_id}`}>{fancy?.back_price1}</div>
                                <span className="widthhundredfancy text-[10px]" id={`fancy_back_size_${fancy.selection_id}`}>{fancy?.back_size1}</span>
                            </button>
                        </div>
                    </div>
                </td>
                <td className="hidden lg:flex float-right w-full text-[#000] font-bold px-px py-[2px] relative text-center w-[15.7%] border-t-[1px] border-[#dee2e6]">
                    <div className="min-max-price text-[11px] absolute right-[10px] text-right top-[2px]">
                        <span className="block text-[11px]">Max:<span>100K</span></span>
                        <span className="block text-[11px]">MKT:<span>1000K</span></span>
                    </div>
                </td>
            </tr>
            {
                showBetsSlip && is_fancy && selection_id == fancy.selection_id && fancy.game_status == '' &&
                <BetsSlipForFancy
                    eventData={eventData}
                    fancy={fancy}
                    type={type}
                    setSelection_id={setSelection_id}
                    setHtmlId={setHtmlId}
                    handlePriceValue={handlePriceValue}
                    BetPlaceData={BetPlaceData}
                    placeStakeValue={placeStakeValue}
                    StakeValue={StakeValue}
                    showBetsSlip={showBetsSlip}
                    setShowBetsSlip={setShowBetsSlip}
                    setSize={setSize}
                    betPlace={betPlace}
                    loading={loading}
                    chips={chips}
                />
            }
        </>
    )
}

export default Fancy